import { render, staticRenderFns } from "./WxDialog.vue?vue&type=template&id=c13ac7e0&scoped=true&"
import script from "./WxDialog.vue?vue&type=script&lang=js&"
export * from "./WxDialog.vue?vue&type=script&lang=js&"
import style0 from "./WxDialog.vue?vue&type=style&index=0&id=c13ac7e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13ac7e0",
  null
  
)

export default component.exports